module.exports = __webpack_public_path__ + "img/sunshine-page_600.e912c113.png";